<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          headline="Sổ sách Giáo viên"
          :link="[
            {
              text: 'Cấp học',
              href: '/teacherDoc'
            },
            {
              text: 'Sổ sách giáo viên'
            }
          ]"
        />
      </div>
    </div>
    <div id="app">
      <div v-if="isLoading" class="center-screen">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
      <div v-else>
        <TreeNode v-if="treeData.children && treeData.children.length > 0" :node="treeData"></TreeNode>
        <TreeNode
          v-if="homeClassTreeData.children && homeClassTreeData.children.length > 0"
          :node="homeClassTreeData"
        ></TreeNode>
      </div>
    </div>
  </div>
</template>

<script>
import TreeNode from '@/components/basic/tree/TreeNode.vue'
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import { mapActions, mapState, mapGetters } from 'vuex'
import { TeacherCat } from '@/plugins/api'

export default {
  components: {
    TreeNode,
    Breadcrumbs
  },
  computed: {
    ...mapState('auth', ['profile']),
    ...mapGetters('auth', ['profile', 'role', 'user'])
  },
  data() {
    return {
      treeData: {
        name: 'Sổ sách giảng dạy',
        children: []
      },
      homeClassTreeData: { name: 'Chủ nhiệm ', children: [] },
      isLoading: true
    }
  },
  async mounted() {
    this.isLoading = true
    try {
      await Promise.all([this.initializeTeachingsTree(), this.initializeHomeClassTree()])
    } catch (error) {
      console.error('Error initializing data:', error)
    } finally {
      this.isLoading = false
    }
  },
  methods: {
    ...mapActions('teacherDoc', ['fetchTeachings']),

    async initializeTeachingsTree() {
      const type = this.$route.params.level
      try {
        const organizedData = await TeacherCat.fetchTree(type, 'teacher', this.profile.id)
        this.treeData.children = organizedData
        this.treeData.name = `Sổ sách giảng dạy cấp ${type === 'high' ? 3 : 2} `
      } catch (error) {
        console.error('Failed to fetch teachings data:', error)
      }
    },

    async initializeHomeClassTree() {
      const type = this.$route.params.level
      try {
        const organizedData = await TeacherCat.fetchTree(type, 'class', this.profile.id)
        this.homeClassTreeData.name = `Chủ nhiệm cấp ${type === 'high' ? 3 : 2} `
        this.homeClassTreeData.children = organizedData
      } catch (error) {
        console.error('Failed to fetch teachings data:', error)
      }
    }
  }
}
</script>
<style scoped>
.center-screen {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
}
</style>
